import React from 'react'
import { i18n } from '../../index'
import { Mutation } from 'react-apollo'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { createMarketQuestion, updateMarketQuestion, fetchMarketQuestions } from './marketQuestionQueries'
import type { MarketQuestion } from './marketQuestionTypes'
import css from './marketQuestionForm.css'
const defaultFormData = {
  id: null,
  description: '',
}

const updateCacheOnUpdate = (cache: any, { data: { updateMarketQuestion } }: any) => {
  const { marketQuestions } = cache.readQuery({
    query: fetchMarketQuestions,
  })
  cache.writeQuery({
    query: fetchMarketQuestions,
    data: {
      marketQuestions: marketQuestions.map((mq) => {
        return mq.id === updateMarketQuestion.id ? updateMarketQuestion : mq
      }),
    },
  })
}

const updateCacheOnCreate = (cache: any, { data: { createMarketQuestion } }: any) => {
  const { marketQuestions } = cache.readQuery({
    query: fetchMarketQuestions,
  })
  cache.writeQuery({
    query: fetchMarketQuestions,
    data: {
      marketQuestions: [...marketQuestions, { ...createMarketQuestion, __typename: 'MarketQuestion' }],
    },
  })
}

type MarketQuestionFormProps = {
  data: MarketQuestion | null | undefined
  onSubmit: (...args: Array<any>) => any
  onCancel: (...args: Array<any>) => any
}
type MarketQuestionFormState = {
  formData: MarketQuestion
}

class MarketQuestionForm extends React.Component<MarketQuestionFormProps, MarketQuestionFormState> {
  state = {
    formData: { ...defaultFormData },
  }

  componentDidMount() {
    const { data } = this.props

    if (data) {
      this.setStateFromData(data)
    }
  }

  componentDidUpdate(prevProps: MarketQuestionFormProps) {
    const { data } = this.props

    if (data && JSON.stringify(data) !== JSON.stringify(prevProps.data)) {
      this.setStateFromData(data)
    }
  }

  setStateFromData = (data: MarketQuestion) => {
    this.setState({
      formData: { ...defaultFormData, ...data },
    })
  }
  onInput = (fielddescription: string, newValue: string | number) => {
    this.setState({
      formData: { ...this.state.formData, [fielddescription]: newValue },
    })
  }
  onSubmit = (onMutate: (...args: Array<any>) => any, e: any) => {
    e.preventDefault()
    const { id, description } = this.state.formData
    const variables = id
      ? {
          id,
          description,
        }
      : {
          description,
        }
    const update = id ? updateCacheOnUpdate : updateCacheOnCreate
    onMutate({
      variables,
      update,
    })
    this.props.onSubmit()
    this.onReset()
  }
  onReset = () => {
    this.setState({
      formData: { ...defaultFormData },
    })
  }

  render() {
    const { onCancel } = this.props
    const { formData } = this.state
    return (
      <Mutation mutation={formData.id ? updateMarketQuestion : createMarketQuestion}>
        {(onMutate) => (
          <form noValidate onSubmit={(e) => this.onSubmit(onMutate, e)} className={css.component}>
            <TextField
              autoFocus
              required
              label={i18n.t('admin.marketQuestion.label.description')}
              value={formData.description}
              onChange={(e) => this.onInput('description', e.target.value)}
              className={css.textField}
            />
            <DialogActions className={css.actions}>
              <Button type='button' onClick={onCancel}>
                {i18n.t('buttons.cancel')}
              </Button>
              <Button type='submit' color='primary'>
                {i18n.t('buttons.save')}
              </Button>
            </DialogActions>
          </form>
        )}
      </Mutation>
    )
  }
}

export default MarketQuestionForm
